module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAMBAMAAAA3/zYzAAAAHlBMVEUAAADDpl/Dpl/Dpl/Dpl/Dpl/Dpl/Dpl/Dpl/Dpl9FOTbJAAAACXRSTlMAmYJLhckTEggjsU6pAAAAWElEQVQY02PADxoYGJgUGAgAZncGBs1JhFQZihQwzZypQMAoQUF3zZkzCRhmKCgoOhMIFAgYJRgJVAQ0TBAXQFZFiY0IK91AricYEgmEQ4KB2Q0RqoRjCAAnCBqMg5NezQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/goldRight.png
// module id = DJAL
// module chunks = 1